import Vue from 'vue'
import Router from 'vue-router'
import '../../common/skin.ts';
// import '../../common/car-skin.ts';
import { bridge } from '../../common'

const HelloWorld = (resolve:any) =>(require(["../components/HelloWorld.vue"],resolve))
const List = (resolve:any) =>(require(["../components/list.vue"],resolve))
const Detail = (resolve:any) =>(require(["../components/detail.vue"],resolve))
const Add = (resolve:any) =>(require(["../components/add.vue"],resolve))
const Edit = (resolve:any) =>(require(["../components/edit.vue"],resolve))
const InvoiceNotice = (resolve:any) =>(require(["../components/invoice-notice.vue"],resolve))
const Entry = (resolve:any) =>(require(["../components/entry.vue"],resolve))

// import HelloWorld from '../components/HelloWorld.vue'
// import List from '../components/list.vue'
// import Detail from '../components/detail.vue'
// import Add from '../components/add.vue'
// import Edit from '../components/edit.vue'


const ElectronicList = (resolve:any) =>(require(["../components/electronic-list.vue"],resolve))
const ElectronicDetail = (resolve:any) =>(require(["../components/electronic-detail.vue"],resolve))
const ElectronicPreview = (resolve:any) =>(require(["../components/electronic-preview.vue"],resolve))
const ElectronicDownload = (resolve:any) =>(require(["../components/electronic-download.vue"],resolve))

// import ElectronicList from '../components/electronic-list.vue'
// import ElectronicDetail from '../components/electronic-detail.vue'
// import ElectronicPreview from '../components/electronic-preview.vue'
// import ElectronicDownload from '../components/electronic-download.vue'

Vue.use(Router)

// Vue-router在3.1之后把$router.push()方法改为了Promise。所以假如没有回调函数，错误信息就会交给全局的路由错误处理，因此就会报上述的错误。
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  routes: [
    {
      name: 'list',
      path: '/list',
      alias: '/',
      component: List,
      meta: { title: '发票助手' }
    },
    {
      name: 'detail',
      path: '/detail/:id',
      component: Detail,
      meta: { title: '抬头详情' }
    },
    {
      name: 'add',
      path: '/add',
      component: Add,
      meta: { title: '添加抬头' }
    },
    {
      name: 'edit',
      path: '/edit/:id',
      component: Edit,
      meta: { title: '编辑抬头' }
    },
    {
      name: 'electronic-list',
      path: '/electronic-list',
      component: ElectronicList,
      meta: { title: '发票助手' }
    },
    {
      name: 'electronic-detail',
      path: '/electronic-detail',
      component: ElectronicDetail,
      meta: { title: '发票详情' }
    },
    {
      name: 'electronic-download',
      path: '/electronic-download',
      component: ElectronicDownload,
      meta: { title: '发送到邮箱' }
    },
    {
      name: 'electronic-preview',
      path: '/electronic-preview',
      component: ElectronicPreview,
      meta: { title: '查看发票' }
    },
    {
      name: 'HelloWorld',
      path: '/HelloWorld',
      component: HelloWorld,
      meta: { title: 'HelloWorld' }
    },
    {
      name: 'invoiceNotice',
      path: '/invoiceNotice',
      component: InvoiceNotice,
      meta: { title: '开票须知' }
    },
    {
      name: 'entry',
      path: '/entry',
      component: Entry
    }
  ]
})

router.afterEach((to, from) => {
  if (to.meta.title) {
    bridge.setTitle(to.meta.title);
  }
  if (Owl) {
    if (location.href.indexOf('useInvoice') > -1) {
      Owl.config({
        pageUrl: `title-useInvoice-${to.name}`
      });
    } else {
      Owl.config({
        pageUrl: `title-${to.name}`
      });
    }
  }

  // if (to.name !== 'detail') {
  //   bridge.clearRRBtn();
  // }

  // if (to.name === 'list') {
  //   document.getElementById('page-loader').style.display = 'flex';
  // } else {
  //   document.getElementById('page-loader').style.display = 'none';
  // }
});

router.onError((error) => {
  console.log(error.message);
});

export default router
